import dayjs from 'dayjs'

// token
export const TOKEN = 'token'
// userInfo
export const USERINFO = 'userInfo'
// token 时间戳
export const TIME_STAMP = 'timeStamp'
// 超时时长(毫秒) 两小时
export const TOKEN_TIMEOUT_VALUE = 2 * 3600 * 1000
// 国际化
export const LANG = 'language'
// 主题色保存的 key
export const MAIN_COLOR = 'mainColor'
// 默认色值
export const DEFAULT_COLOR = '#409eff'
// tags
export const TAGS_VIEW = 'tagsView'

export const URL_LIST = [
  {
    name: '个人中心',
    url: 'https://patient.igensoft.com.cn/#/home/'
  },
  {
    name: '新增预约',
    url: 'https://patient.igensoft.com.cn/#/appointment/add/'
  },
  {
    name: '会员卡中心',
    url: 'https://patient.igensoft.com.cn/#/membership/'
  },
  {
    name: '消费中心',
    url: 'https://patient.igensoft.com.cn/#/receipt/'
  },
  {
    name: '病历中心',
    url: 'https://patient.igensoft.com.cn/#/emr/'
  },
  {
    name: '预约中心',
    url: 'https://patient.igensoft.com.cn/#/appointment/'
  },
  {
    name: '关于诊所',
    url: 'https://patient.igensoft.com.cn/#/clinicMsg/'
  },
  {
    name: '医生团队',
    url: 'https://patient.igensoft.com.cn/#/docGroup/'
  }
]

export const DOC_MENU = [
  {
    title: '1影像资料',
    value: '1'
  },
  {
    title: '2上传影像',
    value: '2'
  },
  {
    title: '3病历修改',
    value: '3'
  },
  {
    title: '4会诊模块',
    value: '4'
  },
  {
    title: '5挂号评价',
    value: '5'
  }
]

// 分页每页数量
export const PAGE_SIZE = 10
export const SMALL_PAGE_SIZE = 5

export const shortcuts = [
  {
    text: '一个月',
    value: () => {
      const date = new Date()
      date.setTime(+dayjs(date.getTime()).add(1, 'month'))
      return date
    }
  },
  {
    text: '两个月',
    value: () => {
      const date = new Date()
      date.setTime(+dayjs(date.getTime()).add(2, 'month'))
      return date
    }
  },
  {
    text: '三个月',
    value: () => {
      const date = new Date()
      date.setTime(+dayjs(date.getTime()).add(3, 'month'))
      return date
    }
  },
  {
    text: '一年',
    value: () => {
      const date = new Date()
      date.setTime(+dayjs(date.getTime()).add(1, 'year'))
      return date
    }
  },
  {
    text: '两年',
    value: () => {
      const date = new Date()
      date.setTime(+dayjs(date.getTime()).add(2, 'year'))
      return date
    }
  },
  {
    text: '五年',
    value: () => {
      const date = new Date()
      date.setTime(+dayjs(date.getTime()).add(5, 'year'))
      return date
    }
  }
]

export const ApprovalTypeMap = {
  // eslint-disable-next-line
  [1]: '首次申请开通应用',
  // eslint-disable-next-line
  [2]: '到期续费',
  // eslint-disable-next-line
  [3]: '申请功能升级',
  // eslint-disable-next-line
  [4]: '续费和功能升级',
  // eslint-disable-next-line
  [5]: '其他'
}

// STS 上传数据
export const REGION = 'oss-cn-shanghai'
export const BUCKET = 'water-drop-assets-wang'

export const accessKeyId = 'LTAI5tLtPxTfRztF3oZVkbiM'
export const accessKeySecret = '2vdMqAxc4k9dcX8v1LaJFonxcna92s'

// AccessKey ID
// LTAI5tDRT3vjhnfNiWaLwsE6
// AccessKey Secret
// QTOzjZMHxrWsMoSmV7gn03EQ457NIn
